import { render, staticRenderFns } from "./UserUnsubscribedAccountsList.vue?vue&type=template&id=6a3c88d2&"
import script from "./UserUnsubscribedAccountsList.vue?vue&type=script&lang=ts&"
export * from "./UserUnsubscribedAccountsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QInput,QIcon,QItem,QItemSection,QBtn} from 'quasar'
component.options.components = Object.assign({QList,QInput,QIcon,QItem,QItemSection,QBtn}, component.options.components || {})
